import { render, staticRenderFns } from "./internalResourceImage1.vue?vue&type=template&id=0587cd15&scoped=true"
import script from "./internalResourceImage1.vue?vue&type=script&lang=js"
export * from "./internalResourceImage1.vue?vue&type=script&lang=js"
import style0 from "./internalResourceImage1.vue?vue&type=style&index=0&id=0587cd15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0587cd15",
  null
  
)

export default component.exports